var exports = {
  "h": "x127c5a35--42380c--description",
};

module.exports = exports;
